import set from 'lodash/set'
import deepValues from '@converdy/utils/deep-values'
import pathTo from '@converdy/utils/path-to'

import generateId from './generate-id'

/**
	 * 
	 * @param {*} id id to replace recursively in the entities object
	 * @param {*} entities things that have a slots property compliant with the converdy-slots-spec
	 * 
	 * MUTATES the entities object. Returns the oldId, newId and the mutated entities object
	 */
export default function replaceId(oldId, entities) {
	const newId = generateId()

	/* Change key */
	const element = entities[oldId]

	const { parentId } = element 

	entities[newId] = element

	entities[newId].id = newId

	/*
	 * update the parentId of all direct children
	 * to the new id of this element (their parent element)
	 * if it has any children
	 */
	if (element.slots) {
		deepValues(element.slots).forEach(
			id => entities[id].parentId = newId
		)
	}

	delete entities[oldId]

	/*
	 * find where the oldId is located in the parent s]lot
	 * and replace it with the newId
	 */
	const pathToOldIdInParentSlots = pathTo(
		oldId,
		entities[parentId].slots
	)

	set(
		entities[parentId].slots,
		pathToOldIdInParentSlots,
		newId
	)

	return {
		oldId,
		newId,
		entities
	}
}
